import { Component, Input } from '@angular/core';

@Component({
  selector: 'bepatient-measure-list-header',
  templateUrl: './measure-list-header.component.html',
  styleUrls: ['./measure-list-header.component.scss'],
  standalone: false
})
export class MeasureListHeaderComponent {
  _icon: string;

  @Input() title: string;

  @Input()
  set icon(i: string) {
    this._icon = `/common/assets/images/bepatient-${i}.svg`;
  }
  get icon() {
    return this._icon;
  }
}
